module.exports = "<p class='h2'>{{label}}: {{value}}</p>";


//////////////////
// WEBPACK FOOTER
// ./src/ractive/components/views/counter-label.html
// module id = 114
// module chunks = 0